import { Template, TemplateItem } from './types';

// Default templates - used to initialize localStorage on first load
export const DEFAULT_TEMPLATES: Template[] = [
  {
    id: 'tmpl-01',
    name: 'Basic Terrace Garden (100 sqft)',
    description: 'Starter package for a 100 sqft terrace garden with planters, plants, irrigation, and installation.',
    items: [
      { description: 'Consultation & site visit', hsn: '998391', qty: 1, unit: 'Job', rate: 2500, gstRate: 18 },
      { description: 'Organic potting mix', hsn: '3101', qty: 10, unit: 'Bag', rate: 350, gstRate: 5 },
      { description: 'Cocopeat (loose / compressed blocks)', hsn: '1404', qty: 5, unit: 'Nos', rate: 280, gstRate: 5 },
      { description: 'FRP (Fibre-Reinforced Plastic) planters', hsn: '3926', qty: 10, unit: 'Nos', rate: 1800, gstRate: 18 },
      { description: 'Ornamental / flowering plants (potted)', hsn: '0602', qty: 18, unit: 'Plant', rate: 250, gstRate: 0 },
      { description: 'Drip irrigation kit (terrace / rooftop)', hsn: '8424', qty: 1, unit: 'Set', rate: 8500, gstRate: 12 },
      { description: 'Terrace garden installation (per sqft)', hsn: '9954', qty: 100, unit: 'Sqft', rate: 85, gstRate: 18 },
      { description: 'Organic kit (fertiliser + pest control combo)', hsn: '3101', qty: 1, unit: 'Set', rate: 850, gstRate: 5 },
    ],
  },
  {
    id: 'tmpl-02',
    name: 'Kitchen / Vegetable Garden',
    description: 'Complete kitchen garden setup with grow bags, vegetable saplings, and organic inputs.',
    items: [
      { description: 'HDPE grow bags (12", 18", 24")', hsn: '3923', qty: 15, unit: 'Nos', rate: 120, gstRate: 18 },
      { description: 'HDPE grow bags (12", 18", 24")', hsn: '3923', qty: 10, unit: 'Nos', rate: 80, gstRate: 18 },
      { description: 'Cocopeat (loose / compressed blocks)', hsn: '1404', qty: 5, unit: 'Bag', rate: 280, gstRate: 5 },
      { description: 'Compost / vermicompost', hsn: '3101', qty: 3, unit: 'Bag', rate: 320, gstRate: 5 },
      { description: 'Vegetable & herb saplings', hsn: '0602', qty: 30, unit: 'Plant', rate: 60, gstRate: 0 },
      { description: 'Vegetable & herb saplings', hsn: '0602', qty: 10, unit: 'Plant', rate: 60, gstRate: 0 },
      { description: 'Organic kit (fertiliser + pest control combo)', hsn: '3101', qty: 1, unit: 'Set', rate: 850, gstRate: 5 },
      { description: 'Planting & soil preparation (per sqft)', hsn: '9986', qty: 1, unit: 'Job', rate: 3500, gstRate: 18 },
    ],
  },
  {
    id: 'tmpl-03',
    name: 'Vertical Garden (20–50 sqft)',
    description: 'Modular vertical garden with pocket panels, shade plants, and gravity-feed irrigation.',
    items: [
      { description: 'Vertical garden pocket panels', hsn: '3926', qty: 30, unit: 'Sqft', rate: 450, gstRate: 18 },
      { description: 'GI trellis / lattice panel', hsn: '7308', qty: 1, unit: 'Set', rate: 6500, gstRate: 18 },
      { description: 'Indoor shade-tolerant plants (Pothos, Fern, Money Plant)', hsn: '0602', qty: 60, unit: 'Plant', rate: 180, gstRate: 0 },
      { description: 'Cocopeat (loose / compressed blocks)', hsn: '1404', qty: 5, unit: 'Bag', rate: 280, gstRate: 5 },
      { description: 'Drip irrigation kit (terrace / rooftop)', hsn: '8424', qty: 1, unit: 'Set', rate: 6000, gstRate: 12 },
      { description: 'Vertical garden installation (per sqft)', hsn: '9954', qty: 30, unit: 'Sqft', rate: 120, gstRate: 18 },
    ],
  },
  {
    id: 'tmpl-04',
    name: 'Pergola & Outdoor Seating',
    description: 'MS pergola with shade net, outdoor furniture, pathway lighting, and climbing plants.',
    items: [
      { description: 'MS / GI pergola framework', hsn: '7308', qty: 1, unit: 'Set', rate: 45000, gstRate: 18 },
      { description: 'Pergola / structure installation', hsn: '9954', qty: 1, unit: 'Job', rate: 15000, gstRate: 18 },
      { description: 'Anti-UV shade net (HDPE)', hsn: '5608', qty: 100, unit: 'Sqft', rate: 45, gstRate: 12 },
      { description: 'Outdoor seating set (table + chairs)', hsn: '9401', qty: 1, unit: 'Set', rate: 22000, gstRate: 18 },
      { description: 'WPC / composite decking (per sqft)', hsn: '4418', qty: 75, unit: 'Sqft', rate: 220, gstRate: 18 },
      { description: 'LED garden / pathway lights', hsn: '9405', qty: 6, unit: 'Nos', rate: 1200, gstRate: 18 },
      { description: 'Creepers & climbers', hsn: '0602', qty: 5, unit: 'Plant', rate: 350, gstRate: 0 },
    ],
  },
  {
    id: 'tmpl-05',
    name: 'Water Feature',
    description: 'GRC fountain with submersible pump, pond liner, aquatic plants, and underwater lighting.',
    items: [
      { description: 'GRC / FRP water fountain', hsn: '6810', qty: 1, unit: 'Nos', rate: 35000, gstRate: 12 },
      { description: 'Water feature pump (submersible)', hsn: '8413', qty: 1, unit: 'Nos', rate: 4500, gstRate: 18 },
      { description: 'Pond liner (EPDM / HDPE)', hsn: '3921', qty: 30, unit: 'Sqft', rate: 180, gstRate: 18 },
      { description: 'Aquatic / pond plants', hsn: '0602', qty: 8, unit: 'Plant', rate: 300, gstRate: 0 },
      { description: 'Underwater LED pond lights', hsn: '9405', qty: 3, unit: 'Nos', rate: 1800, gstRate: 18 },
      { description: 'Water feature installation', hsn: '9954', qty: 1, unit: 'Job', rate: 12000, gstRate: 18 },
    ],
  },
  {
    id: 'tmpl-06',
    name: 'Office Plantation / Interior Landscaping',
    description: 'Indoor plants with decorative pots, installation, and 12-month AMC.',
    items: [
      { description: 'Indoor shade-tolerant plants (Pothos, Fern, Money Plant)', hsn: '0602', qty: 20, unit: 'Plant', rate: 220, gstRate: 0 },
      { description: 'FRP (Fibre-Reinforced Plastic) planters', hsn: '3926', qty: 20, unit: 'Nos', rate: 1600, gstRate: 18 },
      { description: 'Organic potting mix', hsn: '3101', qty: 5, unit: 'Bag', rate: 350, gstRate: 5 },
      { description: 'Office plantation / interior landscaping', hsn: '9986', qty: 1, unit: 'Job', rate: 18000, gstRate: 18 },
      { description: 'Monthly gardening visit', hsn: '9986', qty: 12, unit: 'Nos', rate: 3000, gstRate: 18 },
    ],
  },
  {
    id: 'tmpl-07',
    name: 'Annual Maintenance Contract (AMC)',
    description: 'Full-year AMC with monthly visits, quarterly care, seasonal replanting, and emergency call-outs.',
    items: [
      { description: 'Monthly gardening visit', hsn: '9986', qty: 12, unit: 'Nos', rate: 3500, gstRate: 18 },
      { description: 'Quarterly fertilisation & pest control', hsn: '9986', qty: 4, unit: 'Nos', rate: 2500, gstRate: 18 },
      { description: 'Quarterly fertilisation & pest control', hsn: '9986', qty: 4, unit: 'Nos', rate: 2000, gstRate: 18 },
      { description: 'Seasonal replanting service', hsn: '9986', qty: 2, unit: 'Job', rate: 5000, gstRate: 18 },
      { description: 'Soil testing & report', hsn: '9983', qty: 2, unit: 'Job', rate: 1500, gstRate: 18 },
      { description: 'Emergency garden call-out', hsn: '9986', qty: 2, unit: 'Nos', rate: 1500, gstRate: 18 },
    ],
  },
];
